import { render } from "./app.layouts.vue?vue&type=template&id=21b47c1b"
import script from "./app.layouts.vue?vue&type=script&lang=js"
export * from "./app.layouts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__